import { render, staticRenderFns } from "./MedicalAct.vue?vue&type=template&id=2276ff3c"
import script from "./MedicalAct.vue?vue&type=script&lang=js"
export * from "./MedicalAct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports